import toast from 'react-hot-toast';

/**
 * Privacy mode is turned off only with the Presentation PIN. A screen that has its own "privacy" button (the AOC control tower, the Ops Inbox) must not
 * switch it off itself, and it must not do it through the address either: it asks the toolbar toggle (PresentationModeToggle, which holds the PIN dialog)
 * to open. When no toggle is on the page the request changes nothing and says so; masking stays on.
 */
export const PRIVACY_REVEAL_EVENT = 'pt:request-privacy-reveal';

export function requestPrivacyReveal(): void {
  if (typeof window === 'undefined') return;
  const event = new CustomEvent(PRIVACY_REVEAL_EVENT, { cancelable: true });
  window.dispatchEvent(event);
  // A toggle that took the request calls preventDefault().
  if (!event.defaultPrevented) {
    toast('Privacy mode stays on. Use the shield button at the top right and enter your Presentation PIN to reveal the data.', { icon: '🔒' });
  }
}
